import type { PageResponseType, ResponseType } from '@/types/common';
import httpUtil from '@/utils/http';

const request = httpUtil.mfd.request;
const prefix = 'api/v1';

/**
 * @description WMS收料单
 */
export const wmsReceiveBillApi = {
  list(params: {
    orgId?: number;
    date?: string[];
    status?: string;
    rowStatus?: string;
    billNo?: string;
    materialNumber?: string;
    materialName?: string;
    isRushOrder?: string;
    isPush?: string;
    billType?: string;
    stockName?: string;
    areaStockName?: string;
    urgentStatus?: string[];
  }): PageResponseType {
    return request({
      url: prefix + '/wmsReceiveBill/list',
      method: 'GET',
      params,
    });
  },

  /**
   * @description 仓库下拉选项
   */
  areaStockOptions(params: { orgId?: number }): ResponseType<Array<{ label: string; value: string }>> {
    return request({
      url: prefix + '/wmsReceiveBill/areaStockOptions',
      method: 'GET',
      params,
    });
  },

  /**
   * @description 库区下拉选项
   */
  stockOptions(params: { orgId?: number }): ResponseType<Array<{ label: string; value: string }>> {
    return request({
      url: prefix + '/wmsReceiveBill/stockOptions',
      method: 'GET',
      params,
    });
  },

  /**
   * @description 下推
   */
  push(data: { billNo: string; entryIds: number[]; materials: string[] }): ResponseType {
    return request({
      url: prefix + '/wmsReceiveBill/push',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 加急
   */
  urgent(data: { entryIds: string[]; isRushOrder: boolean; expectFinishAt: number | null }): ResponseType {
    return request({
      url: prefix + '/wmsReceiveBill/urgent',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 导出
   */
  export(params: any): any {
    return request({
      url: prefix + '/wmsReceiveBill/export',
      method: 'GET',
      params,
      responseType: 'arraybuffer',
    });
  },
};
